import _regeneratorRuntime from "/home/azureuser/actions-runner/_work/Admin.WebReact/Admin.WebReact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toArray from "/home/azureuser/actions-runner/_work/Admin.WebReact/Admin.WebReact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "/home/azureuser/actions-runner/_work/Admin.WebReact/Admin.WebReact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/azureuser/actions-runner/_work/Admin.WebReact/Admin.WebReact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/azureuser/actions-runner/_work/Admin.WebReact/Admin.WebReact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/azureuser/actions-runner/_work/Admin.WebReact/Admin.WebReact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _defineProperty from "/home/azureuser/actions-runner/_work/Admin.WebReact/Admin.WebReact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useContext, useMemo, createContext, useCallback } from 'react';
import { ReactReduxContext, Provider, useSelector } from 'react-redux';
import { combineReducers, compose, applyMiddleware, createStore as createStore$1 } from 'redux';
import shortId from 'shortid';
import request from 'superagent';
import pathToRegexp from 'path-to-regexp';
var CLEAR = '@@RESIFT/CLEAR';
var FETCH = '@@RESIFT/FETCH';
var ERROR = '@@RESIFT/ERROR';
var SUCCESS = '@@RESIFT/SUCCESS';
var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CLEAR: CLEAR,
  FETCH: FETCH,
  ERROR: ERROR,
  SUCCESS: SUCCESS
});

function CanceledError(message) {
  this.message = message;
  this.isCanceledError = true;
}

CanceledError.prototype = Object.create(Error.prototype);
CanceledError.prototype.name = 'CanceledError';
CanceledError.prototype = new Error();
/** "error" loading state */

var ERROR$1 = 4;
/** "loading" loading state */

var LOADING = 2;
/** "normal" loading state */

var NORMAL = 1;

function createStoreKey(displayName, fetchFactoryId) {
  return "".concat(displayName, " | ").concat(fetchFactoryId);
}
/**
 * a simple mockable timestamp function
 */


function timestamp() {
  return new Date().toISOString();
}

function createActionType(prefix, meta) {
  return "".concat(prefix, " | ").concat(meta.displayName, " | ").concat(meta.fetchFactoryId);
}

function replace(_prev, next) {
  return next;
}

function normalizeMerge(merge, namespace) {
  if (!merge) {
    return _defineProperty({}, namespace, replace);
  }

  if (typeof merge === 'function') {
    return _defineProperty({}, namespace, merge);
  }

  if (typeof merge === 'object') {
    if (!merge[namespace]) {
      return _objectSpread({}, merge, _defineProperty({}, namespace, replace));
    }

    return merge;
  }

  throw new Error('[sharedReducer] Could not match typeof merge. See here for how to define merges: https://resift.org/docs/main-concepts/making-state-consistent#merges');
}

function isFetchAction(action) {
  if (!action) return false;
  if (!action.type) return false;
  return action.type.startsWith(FETCH);
}

function memoize(displayName, actionCreatorFactory, make, conflict) {
  // TODO: may need a way to clear this memo
  var memo = {};

  function memoized() {
    for (var _len = arguments.length, keyArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      keyArgs[_key] = arguments[_key];
    }

    var makeResult = make.apply(void 0, keyArgs);

    if (typeof makeResult !== 'object') {
      throw new Error('[defineFetch]: `make` must return an object');
    }

    var request = makeResult.request;

    if (!keyArgs.every(function (key) {
      return typeof key === 'string' || typeof key === 'number';
    })) {
      throw new Error("[defineFetch] make arguments must be either a string or a number. Check calls to the fetch factory \"".concat(displayName, "\" See here https://resift.org/docs/main-concepts/whats-a-fetch#making-a-fetch-and-pulling-data-from-it"));
    }

    if (typeof request !== 'function') {
      throw new Error('[defineFetch] `request` must be a function in the object that `make` returns`');
    }

    var hash = "key:".concat([].concat(keyArgs, [conflict]).join(' | '));

    if (memo[hash]) {
      return memo[hash];
    }

    memo[hash] = actionCreatorFactory.apply(void 0, keyArgs);
    return memo[hash];
  }

  return memoized;
}

function defineFetch(_ref3) {
  var displayName = _ref3.displayName,
      share = _ref3.share,
      _ref3$conflict = _ref3.conflict,
      conflict = _ref3$conflict === void 0 ? 'cancel' : _ref3$conflict,
      make = _ref3.make,
      staticFetchFactoryId = _ref3.staticFetchFactoryId;
  var fetchFactoryId = staticFetchFactoryId || shortId();
  if (!displayName) throw new Error('`displayName` is required in `defineFetch`');
  if (!make) throw new Error('`make` is required in `defineFetch`');

  if (share) {
    if (!share.namespace) {
      throw new Error('`namespace` is required in `share');
    }
  }

  function fetchFactory() {
    for (var _len2 = arguments.length, keyArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      keyArgs[_key2] = arguments[_key2];
    }

    var makeResult = make.apply(void 0, keyArgs);
    var meta = {
      fetchFactoryId: fetchFactoryId,
      key: "key:".concat(keyArgs.join(' | ')),
      displayName: displayName,
      share: share && _objectSpread({}, share, {
        mergeObj: normalizeMerge(share.merge, share.namespace)
      }),
      conflict: conflict
    };

    function fetch() {
      // the `request` is a curried function.
      // this partially applies the user request arguments. the resulting function is a
      // function that takes in the services object and returns a promise of data
      var resolvablePayload = makeResult.request.apply(makeResult, arguments);

      if (typeof resolvablePayload !== 'function') {
        throw new Error('[defineFetch] Expected `fetch` to return a curried function. https://resift.org/docs/main-concepts/how-to-define-a-fetch#the-request-function');
      } // cancellation mechanism


      var canceledRef = {
        canceled: false
      }; // pointer used to avoid incorrect value in closures

      var subscribers = [];

      resolvablePayload.cancel = function () {
        canceledRef.canceled = true; // don't know why there's this false positive
        // https://github.com/eslint/eslint/issues/12117
        // eslint-disable-next-line no-unused-vars

        var _iterator = _createForOfIteratorHelper(subscribers),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var subscriber = _step.value;
            subscriber();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };

      resolvablePayload.getCanceled = function () {
        return canceledRef.canceled;
      };

      resolvablePayload.onCancel = function (callback) {
        subscribers.push(callback);
      };

      var request = {
        type: createActionType(FETCH, meta),
        meta: meta,
        payload: resolvablePayload
      };
      return request;
    }

    fetch.meta = _objectSpread({}, meta, {
      type: 'FETCH_INSTANCE'
    });
    return fetch;
  }

  var memoizedFetchFactory = memoize(displayName, fetchFactory, make, conflict);
  memoizedFetchFactory.meta = {
    fetchFactoryId: fetchFactoryId,
    displayName: displayName,
    type: 'FETCH_INSTANCE_FACTORY'
  };
  return memoizedFetchFactory;
} // this is for typescript


var typedFetchFactory = function typedFetchFactory() {
  return function (fetchFactory) {
    return fetchFactory;
  };
};

function isSuccessAction(action) {
  if (typeof action !== 'object') return false;
  if (typeof action.type !== 'string') return false;
  return action.type.startsWith(SUCCESS);
}

function isErrorAction(action) {
  if (typeof action !== 'object') return false;
  if (typeof action.type !== 'string') return false;
  return action.type.startsWith(ERROR);
}

var requestsToCancel = new WeakSet(); // function exists simply to encapsulate async/awaits

function handleAction(_x) {
  return _handleAction.apply(this, arguments);
}

function _handleAction() {
  _handleAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
    var state, services, dispatch, action, getState, payload, meta, displayName, fetchFactoryId, key, conflict, _state$actions, _state$actions$storeK, _state$actions$storeK2, storeKey, inflight, dispatchService, getStateService, servicesWithCancel, resolved, successAction, errorAction;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = _ref4.state, services = _ref4.services, dispatch = _ref4.dispatch, action = _ref4.action, getState = _ref4.getState;
            payload = action.payload, meta = action.meta;
            displayName = meta.displayName, fetchFactoryId = meta.fetchFactoryId, key = meta.key, conflict = meta.conflict;
            _context2.prev = 3;
            // `inflight` is the `payload` function of the fetch. it will be defined if there is an action
            // that is currently inflight.
            storeKey = createStoreKey(displayName, fetchFactoryId);
            inflight = state === null || state === void 0 ? void 0 : (_state$actions = state.actions) === null || _state$actions === void 0 ? void 0 : (_state$actions$storeK = _state$actions[storeKey]) === null || _state$actions$storeK === void 0 ? void 0 : (_state$actions$storeK2 = _state$actions$storeK[key]) === null || _state$actions$storeK2 === void 0 ? void 0 : _state$actions$storeK2.inflight;

            if (!inflight) {
              _context2.next = 11;
              break;
            }

            if (!(conflict === 'ignore')) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return");

          case 9:
            // otherwise we should cancel the current request and continue the current request
            inflight.cancel();
            requestsToCancel.add(inflight);

          case 11:
            dispatchService = function dispatchService(action) {
              if (payload.getCanceled()) {
                throw new CanceledError();
              }

              return dispatch(action);
            };

            getStateService = function getStateService() {
              if (payload.getCanceled()) {
                throw new CanceledError();
              }

              return getState();
            }; // goes through all the services and applies the cancellation mechanism


            servicesWithCancel = Object.entries(services).reduce(function (services, _ref21) {
              var _ref22 = _slicedToArray(_ref21, 2),
                  serviceKey = _ref22[0],
                  service = _ref22[1];

              services[serviceKey] = service({
                getCanceled: payload.getCanceled,
                onCancel: payload.onCancel
              });
              return services;
            }, // start with the `dispatch` service and `getState` service (resift provides these by default)
            {
              dispatch: dispatchService,
              getState: getStateService
            }); // this try-catch set is only to ignore canceled errors
            // it re-throws any other error

            _context2.prev = 14;
            _context2.next = 17;
            return payload(servicesWithCancel);

          case 17:
            resolved = _context2.sent;

            if (!requestsToCancel.has(payload)) {
              _context2.next = 20;
              break;
            }

            return _context2.abrupt("return");

          case 20:
            successAction = {
              type: createActionType(SUCCESS, meta),
              meta: meta,
              payload: resolved
            };
            dispatch(successAction);
            _context2.next = 31;
            break;

          case 24:
            _context2.prev = 24;
            _context2.t0 = _context2["catch"](14);

            if (!_context2.t0.isCanceledError) {
              _context2.next = 28;
              break;
            }

            return _context2.abrupt("return");

          case 28:
            if (!requestsToCancel.has(payload)) {
              _context2.next = 30;
              break;
            }

            return _context2.abrupt("return");

          case 30:
            throw _context2.t0;

          case 31:
            _context2.next = 38;
            break;

          case 33:
            _context2.prev = 33;
            _context2.t1 = _context2["catch"](3);
            errorAction = {
              type: createActionType(ERROR, meta),
              meta: meta,
              payload: _context2.t1,
              error: true
            };
            dispatch(errorAction);
            throw _context2.t1;

          case 38:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 33], [14, 24]]);
  }));
  return _handleAction.apply(this, arguments);
}

function createDataService(_ref5) {
  var services = _ref5.services,
      onError = _ref5.onError;
  if (!services) throw new Error('`services` key required');
  if (!onError) throw new Error('`onError` callback required');
  return function (store) {
    return function (next) {
      return function (action) {
        if (!isFetchAction(action)) {
          return next(action);
        }

        var actionPromise = handleAction({
          state: store.getState().dataService,
          services: services,
          dispatch: store.dispatch,
          action: action,
          getState: store.getState
        }).catch(function (e) {
          onError(e); // when awaiting dispatch...
          //    👇 this is the error that will propagate to the awaiter

          throw e;
        });
        next(action);
        return actionPromise;
      };
    };
  };
} // TODO: this file should be removed in favor of putting the clearFetch


function isClearAction(action) {
  if (typeof action !== 'object') return false;
  if (typeof action.type !== 'string') return false;
  return action.type.startsWith(CLEAR);
} // TODO: `defineFetch` creates a memoized "fetch factory" against the key given
// to it so the fetches can be compared via value equal (e.g. `===`).
//
// Investigate: this may be a good place to try to clear memoized fetches


function clearFetch(fetch) {
  var _fetch$meta;

  var isActionCreatorFactory = (fetch === null || fetch === void 0 ? void 0 : (_fetch$meta = fetch.meta) === null || _fetch$meta === void 0 ? void 0 : _fetch$meta.type) === 'FETCH_INSTANCE_FACTORY';

  if (isActionCreatorFactory) {
    throw new Error('[clearFetch] you tried to pass an action creatorFactory to clearFetch. Ask rico until he write docs.');
  }

  return {
    type: createActionType(CLEAR, fetch.meta),
    meta: fetch.meta
  };
}

function actionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!isFetchAction(action) && !isSuccessAction(action) && !isErrorAction(action) && !isClearAction(action)) {
    return state;
  }

  var meta = action.meta;
  var displayName = meta.displayName,
      fetchFactoryId = meta.fetchFactoryId,
      key = meta.key,
      share = meta.share;
  var storeKey = createStoreKey(displayName, fetchFactoryId);

  if (isFetchAction(action)) {
    var _state$storeKey;

    return _objectSpread({}, state, _defineProperty({}, storeKey, _objectSpread({}, state[storeKey], _defineProperty({}, key, _objectSpread({}, state === null || state === void 0 ? void 0 : (_state$storeKey = state[storeKey]) === null || _state$storeKey === void 0 ? void 0 : _state$storeKey[key], {
      shared: !!share,
      inflight: action.payload,
      meta: meta,
      updatedAt: timestamp()
    })))));
  }

  if (isSuccessAction(action)) {
    var _state$storeKey2;

    return _objectSpread({}, state, _defineProperty({}, storeKey, _objectSpread({}, state[storeKey], _defineProperty({}, key, _objectSpread({}, state === null || state === void 0 ? void 0 : (_state$storeKey2 = state[storeKey]) === null || _state$storeKey2 === void 0 ? void 0 : _state$storeKey2[key], {
      inflight: undefined,
      shared: !!share,
      hadSuccess: true,
      data: action.payload,
      errorData: null,
      error: false,
      meta: meta,
      updatedAt: timestamp()
    })))));
  }

  if (isErrorAction(action)) {
    var _state$storeKey3;

    return _objectSpread({}, state, _defineProperty({}, storeKey, _objectSpread({}, state[storeKey], _defineProperty({}, key, _objectSpread({}, state === null || state === void 0 ? void 0 : (_state$storeKey3 = state[storeKey]) === null || _state$storeKey3 === void 0 ? void 0 : _state$storeKey3[key], {
      inflight: undefined,
      shared: !!share,
      errorData: action.payload,
      error: true,
      meta: meta,
      updatedAt: timestamp()
    })))));
  } // otherwise must be a clear action because of the first if statement


  return _objectSpread({}, state, _defineProperty({}, storeKey, Object.entries((state === null || state === void 0 ? void 0 : state[storeKey]) || {}).filter(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 1),
        k = _ref7[0];

    return k !== key;
  }).reduce(function (acc, _ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
        key = _ref9[0],
        value = _ref9[1];

    acc[key] = value;
    return acc;
  }, {})));
}

var initialState = {
  data: {},
  parents: {},
  merges: {}
}; // for each fetch factory, save their normalized merge object into an easy-to-look-up place
// on success, find the merge functions relevant to the current merge

function sharedReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (isFetchAction(action)) {
    var meta = action.meta;
    var displayName = meta.displayName,
        fetchFactoryId = meta.fetchFactoryId,
        key = meta.key,
        share = meta.share; // only run this reducer if this action is `share`d

    if (!share) return state;
    var namespace = share.namespace,
        mergeObj = share.mergeObj;

    var mergeState = _objectSpread({}, state === null || state === void 0 ? void 0 : state.merges); // (eslint bug)
    // eslint-disable-next-line no-unused-vars


    for (var _i = 0, _Object$entries = Object.entries(mergeObj); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          targetNamespace = _Object$entries$_i[0],
          mergeFn = _Object$entries$_i[1];

      var merges = _objectSpread({}, mergeState === null || mergeState === void 0 ? void 0 : mergeState[targetNamespace]);

      merges[namespace] = mergeFn;
      mergeState[targetNamespace] = merges;
    }

    var parentsState = _objectSpread({}, state === null || state === void 0 ? void 0 : state.parents); // (eslint bug)
    // eslint-disable-next-line no-unused-vars


    var parents = _objectSpread({}, parentsState === null || parentsState === void 0 ? void 0 : parentsState[namespace]);

    parents["".concat(displayName, " | ").concat(key, " | ").concat(fetchFactoryId)] = {
      fetchFactoryId: fetchFactoryId,
      key: key,
      displayName: displayName
    };
    parentsState[namespace] = parents;
    return _objectSpread({}, state, {
      merges: mergeState,
      parents: parentsState
    });
  }

  if (isSuccessAction(action)) {
    var _state$merges;

    var _state$data3;

    var _state$data, _state$data2, _state$data2$targetNa;

    var _ret = function () {
      var meta = action.meta,
          payload = action.payload;
      var key = meta.key,
          share = meta.share; // only run this reducer if this action is `share`d

      if (!share) return {
        v: state
      };
      var namespace = share.namespace;
      var merges = (state === null || state === void 0 ? void 0 : (_state$merges = state.merges) === null || _state$merges === void 0 ? void 0 : _state$merges[namespace]) || {};

      var nextData = _objectSpread({}, state === null || state === void 0 ? void 0 : state.data); // (eslint bug)
      // eslint-disable-next-line no-unused-vars


      var _loop = function _loop() {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            targetNamespace = _Object$entries2$_i[0],
            mergeFn = _Object$entries2$_i[1];

        // if the target namespace is the same from the action's namespace
        // we should only apply the merge function over the current key
        if (targetNamespace === namespace) {
          nextData[targetNamespace] = _objectSpread({}, (_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data[targetNamespace], _defineProperty({}, key, mergeFn((_state$data2 = state.data) === null || _state$data2 === void 0 ? void 0 : (_state$data2$targetNa = _state$data2[targetNamespace]) === null || _state$data2$targetNa === void 0 ? void 0 : _state$data2$targetNa[key], payload)));
          return "continue";
        }

        var mergedData = Object.entries((state === null || state === void 0 ? void 0 : (_state$data3 = state.data) === null || _state$data3 === void 0 ? void 0 : _state$data3[targetNamespace]) || {}).reduce(function (acc, _ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
              key = _ref11[0],
              value = _ref11[1];

          acc[key] = mergeFn(value, payload);
          return acc;
        }, {}); // otherwise we should apply the merge function over all the keys

        nextData[targetNamespace] = mergedData;
      };

      for (var _i2 = 0, _Object$entries2 = Object.entries(merges); _i2 < _Object$entries2.length; _i2++) {
        var _ret2 = _loop();

        if (_ret2 === "continue") continue;
      }

      return {
        v: _objectSpread({}, state, {
          data: nextData
        })
      };
    }();

    if (typeof _ret === "object") return _ret.v;
  }

  if (isClearAction(action)) {
    var _meta = action.meta;
    var _displayName = _meta.displayName,
        _fetchFactoryId = _meta.fetchFactoryId,
        _key3 = _meta.key,
        _share = _meta.share; // only run this reducer if this action is `share`d

    if (!_share) return state;
    var _namespace = _share.namespace,
        _mergeObj = _share.mergeObj;

    var _mergeState = _objectSpread({}, state === null || state === void 0 ? void 0 : state.merges); // (eslint bug)
    // eslint-disable-next-line no-unused-vars


    for (var _i3 = 0, _Object$keys = Object.keys(_mergeObj); _i3 < _Object$keys.length; _i3++) {
      var _targetNamespace = _Object$keys[_i3];

      var _merges = _objectSpread({}, _mergeState === null || _mergeState === void 0 ? void 0 : _mergeState[_targetNamespace]);

      delete _merges[_namespace];
      _mergeState[_targetNamespace] = _merges;
    }

    var _parentsState = _objectSpread({}, state === null || state === void 0 ? void 0 : state.parents);

    var parentSet = _objectSpread({}, _parentsState === null || _parentsState === void 0 ? void 0 : _parentsState[_namespace]);

    var parentKey = "".concat(_displayName, " | ").concat(_key3, " | ").concat(_fetchFactoryId);
    delete parentSet[parentKey];

    if (Object.keys(parentSet || {}).length <= 0) {
      delete _parentsState[_namespace];
    } else {
      _parentsState[_namespace] = parentSet;
    }

    var dataState = _objectSpread({}, state === null || state === void 0 ? void 0 : state.data);

    delete dataState[_namespace];
    return _objectSpread({}, state, {
      data: dataState,
      merges: _mergeState,
      parents: _parentsState
    });
  }

  return state;
}

var dataServiceReducer = combineReducers({
  shared: sharedReducer,
  actions: actionsReducer
});
/**
 * used to create the store if the store isn't passed down from redux context
 */

function createStore(dataService) {
  var reducer = combineReducers({
    dataService: dataServiceReducer
  });
  var composeEnhancers = typeof __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ !== 'undefined' ? // eslint-disable-next-line no-undef
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
  var enhancers = composeEnhancers(applyMiddleware(dataService));
  var store = createStore$1(reducer, enhancers);
  return store;
}

function ResiftProvider(_ref12) {
  var children = _ref12.children,
      dataService = _ref12.dataService,
      suppressOutsideReduxWarning = _ref12.suppressOutsideReduxWarning;
  var sawReduxContext = !!useContext(ReactReduxContext);

  if (process.env.NODE_ENV !== 'production') {
    if (sawReduxContext && !suppressOutsideReduxWarning) {
      console.warn("[ResiftProvider] Saw an outside Redux context in this tree. If you're using Redux in your application, you don't need to wrap your app in the ResiftProvider. See https://resift.org/docs/guides/usage-with-redux");
    }
  }

  if (!dataService) {
    throw new Error('[ResiftProvider] `dataService` missing from props.');
  }

  var store = useMemo(function () {
    return createStore(dataService);
  }, [dataService]);
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, children);
}
/** "unknown" loading state */


var UNKNOWN = 0;

function getNormal(status) {
  return (status & NORMAL) !== 0;
}

function isNormal() {
  for (var _len3 = arguments.length, statuses = new Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
    statuses[_key4] = arguments[_key4];
  }

  return statuses.every(getNormal);
}

function getLoading(status) {
  return (status & LOADING) !== 0;
}

function isLoading() {
  for (var _len4 = arguments.length, statuses = new Array(_len4), _key5 = 0; _key5 < _len4; _key5++) {
    statuses[_key5] = arguments[_key5];
  }

  return statuses.some(getLoading);
}

function getError(status) {
  return (status & ERROR$1) !== 0;
}

function isError() {
  for (var _len5 = arguments.length, statuses = new Array(_len5), _key6 = 0; _key6 < _len5; _key6++) {
    statuses[_key6] = arguments[_key6];
  }

  return statuses.some(getError);
}

function getUnknown(status) {
  return status === UNKNOWN;
}

function isUnknown() {
  for (var _len6 = arguments.length, statuses = new Array(_len6), _key7 = 0; _key7 < _len6; _key7++) {
    statuses[_key7] = arguments[_key7];
  }

  return statuses.every(getUnknown);
}

function combineStatuses() {
  if (isUnknown.apply(void 0, arguments)) return UNKNOWN;
  var loading = isLoading.apply(void 0, arguments) ? LOADING : UNKNOWN;
  var normal = isNormal.apply(void 0, arguments) ? NORMAL : UNKNOWN;
  var error = isError.apply(void 0, arguments) ? ERROR$1 : UNKNOWN;
  return loading | normal | error;
} //
// With non-shared statuses, the default behavior is only make `isNormal` return true if all the
// statuses are normal. This is because there could be a loader blocking render until all pieces of
// data come back.
//
// With shared statuses, it makes sense to have `isNormal` return true if only one status is normal
// (vs all). This is because the shared fetches share the same internal store so if one fetch has
// the data, it's sufficient for all of them.


function combineSharedStatuses() {
  for (var _len7 = arguments.length, statuses = new Array(_len7), _key8 = 0; _key8 < _len7; _key8++) {
    statuses[_key8] = arguments[_key8];
  }

  if (statuses.every(function (status) {
    return isUnknown(status);
  })) {
    return UNKNOWN;
  }

  var loading = isLoading.apply(void 0, statuses) ? LOADING : UNKNOWN;
  var normal = statuses.some(function (status) {
    return isNormal(status);
  }) ? NORMAL : UNKNOWN;
  var error = isError.apply(void 0, statuses) ? ERROR$1 : UNKNOWN;
  return loading | normal | error;
}

function getStatus(actionState) {
  if (!actionState) return UNKNOWN;
  var hadSuccess = actionState.hadSuccess,
      inflight = actionState.inflight,
      error = actionState.error;
  var inflightStatus = inflight ? LOADING : UNKNOWN;
  var errorStatus = error ? ERROR$1 : UNKNOWN;
  var normalStatus = hadSuccess && !error ? NORMAL : UNKNOWN;
  return inflightStatus | errorStatus | normalStatus;
}

var makeStatusSelector = function makeStatusSelector(fetch, options) {
  return function (state) {
    var _fetch$meta, _state$dataService, _state$dataService$ac, _state$dataService$ac2;

    if (!fetch) {
      return UNKNOWN;
    }

    var isFetchInstance = (fetch === null || fetch === void 0 ? void 0 : (_fetch$meta = fetch.meta) === null || _fetch$meta === void 0 ? void 0 : _fetch$meta.type) === 'FETCH_INSTANCE';

    if (!isFetchInstance) {
      throw new Error('[useStatus] expected to see a fetch instance in get fetch.');
    }

    if (!state.dataService) {
      throw new Error('[useStatus] "dataService" is a required key. Double check with the installation guide here: https://resift.org/docs/introduction/installation');
    }

    var _fetch$meta2 = fetch.meta,
        fetchFactoryId = _fetch$meta2.fetchFactoryId,
        displayName = _fetch$meta2.displayName,
        key = _fetch$meta2.key,
        share = _fetch$meta2.share;
    var storeKey = createStoreKey(displayName, fetchFactoryId);
    var value = state === null || state === void 0 ? void 0 : (_state$dataService = state.dataService) === null || _state$dataService === void 0 ? void 0 : (_state$dataService$ac = _state$dataService.actions) === null || _state$dataService$ac === void 0 ? void 0 : (_state$dataService$ac2 = _state$dataService$ac[storeKey]) === null || _state$dataService$ac2 === void 0 ? void 0 : _state$dataService$ac2[key];
    var nonSharedStatus = getStatus(value); // if the fetch is _not_ shared, continue down this code path.
    // in this path, all we do is return the "non-shared" value and the "non-shared" state from the
    // `actions` sub-store (vs the `shared` sub-store)

    if (!share) {
      return nonSharedStatus;
    } // otherwise if the fetch _is_ shared, then continue down this code path


    var namespace = share.namespace,
        mergeObj = share.mergeObj;
    var shouldReturnIsolatedStatus = (options === null || options === void 0 ? void 0 : options.isolatedStatus) || false; // if the user put in `isolatedStatus: true` in their options then we should return the status
    // derived from the `actions` sub-store

    if (shouldReturnIsolatedStatus) {
      return nonSharedStatus;
    } // otherwise do all the stuff below to get the shared status


    var targetNamespaces = Object.keys(mergeObj); // `parentLocations` are paths to the state in the `actions` sub-store

    var parentLocationsFromTheSameNamespace = targetNamespaces.map(function (targetNamespace) {
      var _state$dataService2, _state$dataService2$s, _state$dataService2$s2;

      var parentLocations = state === null || state === void 0 ? void 0 : (_state$dataService2 = state.dataService) === null || _state$dataService2 === void 0 ? void 0 : (_state$dataService2$s = _state$dataService2.shared) === null || _state$dataService2$s === void 0 ? void 0 : (_state$dataService2$s2 = _state$dataService2$s.parents) === null || _state$dataService2$s2 === void 0 ? void 0 : _state$dataService2$s2[targetNamespace];

      if (!parentLocations) {
        return null;
      }

      if (targetNamespace !== namespace) {
        return null;
      }

      var validParentLocations = Object.values(parentLocations).filter(function (parentLocation) {
        return parentLocation.key === key;
      });
      return validParentLocations;
    }).filter(function (x) {
      return !!x;
    }).reduce(function (flatten, next) {
      // eslint bug
      // eslint-disable-next-line no-unused-vars
      var _iterator2 = _createForOfIteratorHelper(next),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var i = _step2.value;
          flatten.push(i);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return flatten;
    }, []);
    var parentLocationsFromDifferentNamespaces = targetNamespaces.map(function (targetNamespace) {
      var _state$dataService3, _state$dataService3$s, _state$dataService3$s2;

      var parentLocations = state === null || state === void 0 ? void 0 : (_state$dataService3 = state.dataService) === null || _state$dataService3 === void 0 ? void 0 : (_state$dataService3$s = _state$dataService3.shared) === null || _state$dataService3$s === void 0 ? void 0 : (_state$dataService3$s2 = _state$dataService3$s.parents) === null || _state$dataService3$s2 === void 0 ? void 0 : _state$dataService3$s2[targetNamespace];

      if (!parentLocations) {
        return null;
      }

      if (targetNamespace === namespace) {
        return null;
      }

      return Object.values(parentLocations);
    }).filter(function (x) {
      return !!x;
    }).reduce(function (flatten, next) {
      // eslint bug
      // eslint-disable-next-line no-unused-vars
      var _iterator3 = _createForOfIteratorHelper(next),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var i = _step3.value;
          flatten.push(i);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return flatten;
    }, []); // this takes all those paths and grabs the action sub-state.
    // this sub-state is ran through `getStatus` which returns the corresponding status for the
    // sub-state.

    var sharedStatusesFromSameNamespace = parentLocationsFromTheSameNamespace.map(function (parentLocation) {
      var _state$dataService4, _state$dataService4$a, _state$dataService4$a2;

      var storeKey = createStoreKey(parentLocation.displayName, parentLocation.fetchFactoryId);
      var parentAction = state === null || state === void 0 ? void 0 : (_state$dataService4 = state.dataService) === null || _state$dataService4 === void 0 ? void 0 : (_state$dataService4$a = _state$dataService4.actions) === null || _state$dataService4$a === void 0 ? void 0 : (_state$dataService4$a2 = _state$dataService4$a[storeKey]) === null || _state$dataService4$a2 === void 0 ? void 0 : _state$dataService4$a2[parentLocation.key];
      return getStatus(parentAction);
    }).filter(function (x) {
      return x !== null;
    });
    var sharedStatuesFromDifferentNamespaces = parentLocationsFromDifferentNamespaces.map(function (parentLocation) {
      var _state$dataService5, _state$dataService5$a, _state$dataService5$a2;

      var storeKey = createStoreKey(parentLocation.displayName, parentLocation.fetchFactoryId);
      var parentAction = state === null || state === void 0 ? void 0 : (_state$dataService5 = state.dataService) === null || _state$dataService5 === void 0 ? void 0 : (_state$dataService5$a = _state$dataService5.actions) === null || _state$dataService5$a === void 0 ? void 0 : (_state$dataService5$a2 = _state$dataService5$a[storeKey]) === null || _state$dataService5$a2 === void 0 ? void 0 : _state$dataService5$a2[parentLocation.key];
      return getStatus(parentAction);
    }).filter(function (x) {
      return x !== null;
    });
    var otherNamespaceLoading = sharedStatuesFromDifferentNamespaces.some(function (status) {
      return isLoading(status);
    }) ? LOADING : UNKNOWN; // all of those status are folded into one shared status

    var sharedStatus = otherNamespaceLoading | combineSharedStatuses.apply(void 0, _toConsumableArray(sharedStatusesFromSameNamespace));
    return sharedStatus;
  };
};

function useStatus(fetch, options) {
  // TODO: need to figure-out a sustainable way to do this.
  var isolatedStatus = options === null || options === void 0 ? void 0 : options.isolatedStatus;
  var preservedOptions = useMemo(function () {
    return {
      isolatedStatus: isolatedStatus
    };
  }, [isolatedStatus]);
  var statusSelector = useMemo(function () {
    return makeStatusSelector(fetch, preservedOptions);
  }, [fetch, preservedOptions]);
  return useSelector(statusSelector);
}

var makeDataSelector = function makeDataSelector(fetch) {
  return function (state) {
    var _fetch$meta, _state$dataService, _state$dataService$ac, _state$dataService$ac2, _state$dataService2, _state$dataService2$s, _state$dataService2$s2, _state$dataService2$s3;

    if (!fetch) {
      return null;
    }

    var isFetchInstance = (fetch === null || fetch === void 0 ? void 0 : (_fetch$meta = fetch.meta) === null || _fetch$meta === void 0 ? void 0 : _fetch$meta.type) === 'FETCH_INSTANCE';

    if (!isFetchInstance) {
      throw new Error('[useData] expected to see a fetch instance.');
    }

    if (!state.dataService) {
      throw new Error('[useData] "dataService" is a required key. Double check with the installation guide here: https://resift.org/docs/introduction/installation');
    }

    var _fetch$meta3 = fetch.meta,
        fetchFactoryId = _fetch$meta3.fetchFactoryId,
        displayName = _fetch$meta3.displayName,
        key = _fetch$meta3.key,
        share = _fetch$meta3.share;
    var storeKey = createStoreKey(displayName, fetchFactoryId);
    var value = state === null || state === void 0 ? void 0 : (_state$dataService = state.dataService) === null || _state$dataService === void 0 ? void 0 : (_state$dataService$ac = _state$dataService.actions) === null || _state$dataService$ac === void 0 ? void 0 : (_state$dataService$ac2 = _state$dataService$ac[storeKey]) === null || _state$dataService$ac2 === void 0 ? void 0 : _state$dataService$ac2[key]; // if the fetch is _not_ shared, continue down this code path.
    // in this path, all we do is return the "non-shared" value and the "non-shared" state from the
    // `actions` sub-store (vs the `shared` sub-store)

    if (!share) {
      if (!value) return null;
      return value.data === undefined ? null : value.data;
    } // otherwise if the fetch _is_ shared, then continue down this code path


    var namespace = share.namespace; // the value comes from the `shared` sub-store instead of the `actions` sub-store

    var sharedData = (state === null || state === void 0 ? void 0 : (_state$dataService2 = state.dataService) === null || _state$dataService2 === void 0 ? void 0 : (_state$dataService2$s = _state$dataService2.shared) === null || _state$dataService2$s === void 0 ? void 0 : (_state$dataService2$s2 = _state$dataService2$s.data) === null || _state$dataService2$s2 === void 0 ? void 0 : (_state$dataService2$s3 = _state$dataService2$s2[namespace]) === null || _state$dataService2$s3 === void 0 ? void 0 : _state$dataService2$s3[key]) || null;
    return sharedData;
  };
};

function useData(fetch) {
  var dataSelector = useMemo(function () {
    return makeDataSelector(fetch);
  }, [fetch]);
  return useSelector(dataSelector);
}

function toSnakeCase(displayName) {
  var split = displayName.split(' ');
  return split.map(function (s) {
    return s.replace(/\W/g, '');
  }).map(function (s) {
    return s.substring(0, 1).toUpperCase() + s.substring(1);
  }).join('');
}

function createContextFetch(fetch) {
  var Context = /*#__PURE__*/createContext(null);
  Context.displayName = "FetchProvider".concat(toSnakeCase(fetch.meta.displayName));

  function ContextFetchProvider(_ref13) {
    var children = _ref13.children;
    var value = useData(fetch);
    var status = useStatus(fetch);
    var contextValue = useMemo(function () {
      return [value, status];
    }, [value, status]);
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: contextValue
    }, children);
  }

  function useContextFetch() {
    var contextValue = useContext(Context);

    if (!contextValue) {
      throw new Error('[createContextFetch] could not find global fetch context. Did you forget to wrap this tree with the provider?');
    }

    return contextValue;
  }

  function ContextFetchConsumer(_ref14) {
    var children = _ref14.children;
    return /*#__PURE__*/React.createElement(Context.Consumer, null, children);
  }

  return {
    ContextFetchProvider: ContextFetchProvider,
    useContextFetch: useContextFetch,
    ContextFetchConsumer: ContextFetchConsumer
  };
}
/*
 * this function doesn't do anything more than wrap the params in an object
 * the reason this function exists is for a better library experience when the user is using an
 * editor that supports the typescript language service (e.g. vs-code, webstorm, visual studio)
 */


function createHttpProxy(matchParams, handler) {
  return {
    matchParams: matchParams,
    handler: handler
  };
}
/*
 * taken directly from `react-router`:
 * https://github.com/ReactTraining/react-router/blob/f6eae5e11ed8b26cc936b20b6ee81bafbc43edd2/packages/react-router/modules/matchPath.js
 */


var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path, options) {
  var cacheKey = "".concat(options.end).concat(options.strict).concat(options.sensitive);
  var pathCache = cache[cacheKey] || (cache[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = pathToRegexp(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount < cacheLimit) {
    pathCache[path] = result;
    cacheCount++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string' || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path) return null;
    if (matched) return matched;

    var _compilePath = compilePath(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;

    var _match = _toArray(match),
        url = _match[0],
        values = _match.slice(1);

    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === '/' && url === '' ? '/' : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function getPrefix(_x2, _x3) {
  return _getPrefix2.apply(this, arguments);
}

function _getPrefix2() {
  _getPrefix2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_prefix, _getPrefix) {
    var prefix;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!_prefix) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", _prefix);

          case 2:
            if (!(typeof _getPrefix === 'function')) {
              _context3.next = 7;
              break;
            }

            _context3.next = 5;
            return _getPrefix();

          case 5:
            prefix = _context3.sent;
            return _context3.abrupt("return", prefix);

          case 7:
            return _context3.abrupt("return", '');

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getPrefix2.apply(this, arguments);
}

function _http2(_x4, _x5) {
  return _http.apply(this, arguments);
}

function _http() {
  _http = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref15, _ref16) {
    var method, query, route, ok, reqHandler, data, headers, onCancel, prefix, normalizedMethod, path, req, headerEntries, _i4, _headerEntries, _headerEntries$_i, headerKey, headerValue, payload;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            method = _ref15.method, query = _ref15.query, route = _ref15.route, ok = _ref15.ok, reqHandler = _ref15.req, data = _ref15.data;
            headers = _ref16.headers, onCancel = _ref16.onCancel, prefix = _ref16.prefix;

            /** @type {'get' | 'post' | 'put' | 'delete' | 'patch'} */
            normalizedMethod = method.toLowerCase();
            path = "".concat(prefix).concat(route);
            req = request[normalizedMethod](path).accept('application/json');
            headerEntries = Object.entries(headers); // don't know there's this false positive
            // https://github.com/eslint/eslint/issues/12117
            // eslint-disable-next-line no-unused-vars

            for (_i4 = 0, _headerEntries = headerEntries; _i4 < _headerEntries.length; _i4++) {
              _headerEntries$_i = _slicedToArray(_headerEntries[_i4], 2), headerKey = _headerEntries$_i[0], headerValue = _headerEntries$_i[1];
              req.set(headerKey, headerValue);
            }

            onCancel(function () {
              req.abort();
            });

            if (query) {
              req.query(query);
            }

            if (ok) {
              req.ok(ok);
            }

            if (reqHandler) {
              reqHandler(req);
            }

            if (data) {
              req.send(data);
            }

            _context4.next = 14;
            return req;

          case 14:
            payload = _context4.sent;
            return _context4.abrupt("return", payload.body);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _http.apply(this, arguments);
}

function createHttpService(_ref17) {
  var _prefix = _ref17.prefix,
      _ref17$getHeaders = _ref17.getHeaders,
      getHeaders = _ref17$getHeaders === void 0 ? function () {
    return {};
  } : _ref17$getHeaders,
      _getPrefix = _ref17.getPrefix,
      _ref17$proxies = _ref17.proxies,
      proxies = _ref17$proxies === void 0 ? [] : _ref17$proxies;
  return function (_ref18) {
    var onCancel = _ref18.onCancel,
        getCanceled = _ref18.getCanceled;
    return /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestParams) {
        var route, headers, prefix, httpOptions, proxy, match, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                route = requestParams.route;

                if (process.env.NODE_ENV !== 'production') {
                  if (route.includes('?')) {
                    console.warn("[createHttpService] You included a `?` in your route \"".concat(route, "\". We recommend using `query` instead. https://resift.org/docs/api/create-http-service#httpparams"));
                  }
                }

                _context.prev = 2;

                if (!getCanceled()) {
                  _context.next = 5;
                  break;
                }

                throw new CanceledError();

              case 5:
                _context.next = 7;
                return getHeaders();

              case 7:
                headers = _context.sent;
                _context.next = 10;
                return getPrefix(_prefix, _getPrefix);

              case 10:
                prefix = _context.sent;
                httpOptions = {
                  headers: headers,
                  prefix: prefix,
                  onCancel: onCancel
                };
                proxy = proxies.find(function (proxy) {
                  return matchPath(route, proxy.matchParams);
                });

                if (!proxy) {
                  _context.next = 16;
                  break;
                }

                match = matchPath(route, proxy.matchParams);
                return _context.abrupt("return", proxy.handler({
                  match: match,
                  requestParams: requestParams,
                  headers: headers,
                  onCancel: onCancel,
                  getCanceled: getCanceled,
                  http: function http(requestParams) {
                    return _http2(requestParams, httpOptions);
                  }
                }));

              case 16:
                _context.next = 18;
                return _http2(requestParams, httpOptions);

              case 18:
                data = _context.sent;
                return _context.abrupt("return", data);

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](2);

                if (!(_context.t0.code === 'ABORTED')) {
                  _context.next = 26;
                  break;
                }

                throw new CanceledError();

              case 26:
                throw _context.t0;

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 22]]);
      }));

      return function (_x6) {
        return _ref19.apply(this, arguments);
      };
    }();
  };
}

function useDispatch() {
  var contextValue = useContext(ReactReduxContext);

  if (!contextValue) {
    throw new Error('[useDispatch] Could not find the respective context. In order to `useDispatch` you must add the respective provider. https://resift.org/docs/introduction/installation#adding-the-resiftprovider');
  }

  var store = contextValue.store;
  if (process.env.NODE_ENV === 'production') return store.dispatch; // eslint-disable-next-line react-hooks/rules-of-hooks

  return useCallback(function (action) {
    var _action$meta, _action$meta2;

    var isFetchInstance = (action === null || action === void 0 ? void 0 : (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.type) === 'FETCH_INSTANCE';
    var isFetchFactory = (action === null || action === void 0 ? void 0 : (_action$meta2 = action.meta) === null || _action$meta2 === void 0 ? void 0 : _action$meta2.type) === 'FETCH_INSTANCE_FACTORY';
    var isClearAction = ((action === null || action === void 0 ? void 0 : action.type) || '').startsWith(CLEAR);

    if (isFetchInstance && !isClearAction) {
      // TODO: add docs for this
      throw new Error("[useDispatch] You dispatched a fetch instance without calling it when you should've dispatched a request.");
    }

    if (isFetchFactory) {
      throw new Error( // TODO: add docs for this
      "[useDispatch] You dispatched a fetch factory when you should've dispatched a request.");
    }

    return store.dispatch(action);
  }, [store]);
}

function useClearFetch() {
  var dispatch = useDispatch();
  return useCallback(function (fetch) {
    dispatch(clearFetch(fetch));
  }, [dispatch]);
}

function Guard(_ref20) {
  var fetch = _ref20.fetch,
      children = _ref20.children;
  var data = useData(fetch);
  var status = useStatus(fetch);
  if (!isNormal(status)) return null;
  if (data === null) return null;
  if (data === undefined) return null;
  return children(data);
}

function useFetch(fetch, options) {
  var data = useData(fetch);
  var status = useStatus(fetch, options);
  return useMemo(function () {
    return [data, status];
  }, [data, status]);
}

var makeErrorSelector = function makeErrorSelector(fetch) {
  return function (state) {
    var _fetch$meta, _state$dataService, _state$dataService$ac, _state$dataService$ac2;

    if (!fetch) {
      return null;
    }

    var isFetchInstance = (fetch === null || fetch === void 0 ? void 0 : (_fetch$meta = fetch.meta) === null || _fetch$meta === void 0 ? void 0 : _fetch$meta.type) === 'FETCH_INSTANCE';

    if (!isFetchInstance) {
      throw new Error('[useError] expected to see a fetch instance.');
    }

    if (!state.dataService) {
      throw new Error('[useError] "dataService" is a required key. Double check with the installation guide here: https://resift.org/docs/introduction/installation');
    }

    var _fetch$meta4 = fetch.meta,
        fetchFactoryId = _fetch$meta4.fetchFactoryId,
        displayName = _fetch$meta4.displayName,
        key = _fetch$meta4.key;
    var storeKey = createStoreKey(displayName, fetchFactoryId);
    var value = state === null || state === void 0 ? void 0 : (_state$dataService = state.dataService) === null || _state$dataService === void 0 ? void 0 : (_state$dataService$ac = _state$dataService.actions) === null || _state$dataService$ac === void 0 ? void 0 : (_state$dataService$ac2 = _state$dataService$ac[storeKey]) === null || _state$dataService$ac2 === void 0 ? void 0 : _state$dataService$ac2[key];

    if (!value) {
      return null;
    }

    if (value.errorData === undefined) {
      return null;
    }

    return value.errorData;
  };
};

function useError(fetch) {
  var errorSelector = useMemo(function () {
    return makeErrorSelector(fetch);
  }, [fetch]);
  return useSelector(errorSelector);
}

export { CanceledError, ERROR$1 as ERROR, Guard, LOADING, NORMAL, index as PREFIXES, ResiftProvider, UNKNOWN, combineStatuses, createActionType, createContextFetch, createDataService, createHttpProxy, createHttpService, createStoreKey, dataServiceReducer, defineFetch, isError, isLoading, isNormal, isUnknown, typedFetchFactory, useClearFetch, useData, useDispatch, useError, useFetch, useStatus };